module.exports = __webpack_public_path__ + "img/icon-account.95d97167.svg";